import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { getFilterIds } from "@tIntermatic/Services/NewsFilterService";
import { CustomApiHandler } from "@tIntermatic/Store/CustomHandlerCreator";

type Parameter = {};

type HandlerType = CustomApiHandler<Parameter>;

export const DispatchSetNewsFilters: HandlerType = ({ dispatch }) => {
    dispatch({
        type: "Components/NewsListFilter/SetNewsFilterIds",
        marketFilters: getFilterIds("market"),
        solutionFilters: getFilterIds("solution"),
        typeFilters: getFilterIds("type"),
    });
};

export const chain = [DispatchSetNewsFilters];

const loadNewsFilters = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadNewsFilters");
export default loadNewsFilters;
